import { StationType } from './station-type.enum';
import { Station } from './station';
import { MasterDetailListEntry } from '@sdbn/common';

export class StationSet implements MasterDetailListEntry {
    id: number;
    name: string;
    externalKey: string;
    description: string;
    stationType: StationType;
    stationIds = new Array<number>();
    stations = new Array<Station>();

    constructor(set: Partial<StationSet>) {
        this.id = set.id;
        this.name = set.name;
        this.externalKey = set.externalKey;
        this.description = set.description;
        this.stationType = set.stationType;
        if (set.stationIds != null) {
            for (const stationId of set.stationIds) {
                this.stationIds.push(stationId);
            }
        }
    }

    public get listTitle(): string {
        return this.name;
    }

    public get listTitleDictionaryKey(): string {
        return null;
    }

    public get listSubTitle(): string {
        return null;
    }

    public get groupIdentifier(): String {
      return null;
    }

    public get childs() : Array<MasterDetailListEntry> {
      return null;
    }

}
